import { Icon, IconProps } from '@chakra-ui/react'

export function GradientShieldWithArrowIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 39 47" fill="none" {...props}>
      <g clipPath="url(#clip0_949_2020)">
        <path
          d="M32.9978 38.9169L19.2635 46.8228L5.52925 38.9169C2.36686 37.0967 0.417953 33.732 0.417953 30.0916V0.54541H38.0908V30.0916C38.0908 33.732 36.1418 37.0967 32.9795 38.9169H32.9978Z"
          fill="currentColor"
        />
        <path
          d="M26.8566 18.6557L24.8893 14.7027L20.8996 13.1399C18.7116 12.2758 16.8179 11.43 16.6708 11.2645C16.5421 11.0991 20.9731 8.87436 26.5073 6.35549C32.0415 3.81823 36.6379 1.83254 36.7115 1.94286C36.9137 2.21865 29.3387 22.719 29.0446 22.6822C28.8975 22.6638 27.9046 20.862 26.8199 18.6741L26.8566 18.6557Z"
          fill="url(#paint0_linear_949_2020)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_949_2020"
          x1="16.6892"
          y1="12.2758"
          x2="36.7299"
          y2="12.2758"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFBD" />
          <stop offset={1} stopColor="#0060FF" />
        </linearGradient>
        <clipPath id="clip0_949_2020">
          <rect
            width="37.5287"
            height="46.5232"
            fill="white"
            transform="translate(0.480911 0.301025)"
          />
        </clipPath>
      </defs>
    </Icon>
  )
}
